import { Outlet, createFileRoute } from "@tanstack/react-router";

import { caseDetailQueryOptions } from "@/features/cases/queries";
import { caseTitleCrumb } from "@/lib/crumb-resolvers";

// 注: ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
// 出自 (どの一覧から開いたか) は AppLayout が L1 セクションとして自動捕捉するため、
// ここで `?from=` 等の search は持たない (URL はクリーンなまま)。
export const Route = createFileRoute("/_authenticated/admin/cases/$id")({
  staticData: { crumb: caseTitleCrumb("/admin/cases/$id") },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(caseDetailQueryOptions(params.id)),
  component: () => <Outlet />,
});
